import { 
    SECTIONS_FETCHING,
    SECTIONS_FAILED,
    SECTIONS_SUCCESS
} from "../actions/types";

const initialState = {
    result: null,
    isFetching: false,
    isError: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
      case SECTIONS_FETCHING:
        return { ...state, result: null, isFetching: true, isError: false };
      case SECTIONS_FAILED:
        return { ...state, result: null, isFetching: false, isError: true };
      case SECTIONS_SUCCESS:
        return { ...state, result: payload, isFetching: false, isError: false };
      default:
        return state;
    }
};
